import * as types from "./actionTypes";
import * as userApi from '../../api/userApi';


export function fetchBranch(userId) {
  return function (dispatch) {
      return userApi
          .getBranch(userId)
          .then(branch => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_BRANCH_SUCCESS,
                  branch
              });
          })
          .catch(error => {
              throw error;
          });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js